import { css } from '@emotion/css';
import { colors } from 'constants/theme';
import globalStyle from 'constants/global.style';
import { msgAlertInput } from 'constants/messageAlert';
import { AgentMemberPayload } from 'models/agentModel';
import { UserInfoModel } from 'models/userInfoModel';
import { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { NumericFormat } from 'react-number-format';
import accountStyles from './account-option.style';
import userApi from 'apis/userApi';
import { removeSeperateNumber } from 'utils/function';
import toast from 'react-hot-toast';
import moment from 'moment';
import LoadingIcon from 'components/loading/LoadingIcon';
const orderMemberList = [
    { value: 0, label: 'Thời gian đăng ký mới nhất' },
    { value: 1, label: 'Thời gian đăng ký cũ nhất' },
    { value: 2, label: 'Số dư ít nhất' },
    { value: 3, label: 'Số dư nhiều nhất' },
    { value: 4, label: 'Đăng nhập nhiều nhất' },
    { value: 5, label: 'Đăng nhập gần đây nhất' },
];
function AgentMember() {
    const {
        register,
        handleSubmit,

        control,
        formState: { errors },
    } = useForm<AgentMemberPayload>();
    const [orderData, setOrderData] = useState(0);
    const [memberList, setMemberList] = useState<UserInfoModel[] | null>(null);
    const [loading, setLoading] = useState(false);
    const getMemberAgentList: SubmitHandler<AgentMemberPayload> = async (values) => {
        const { samount, eamount } = values;
        if (samount) values.samount = removeSeperateNumber(samount);
        if (eamount) values.eamount = removeSeperateNumber(eamount);

        setLoading(true);
        const payload: AgentMemberPayload = {
            ...values,
            order: orderData,
            userarea: 0,
        };

        try {
            const { data } = await userApi.agentUserSearch(payload);
            if (!data.msg) {
                setMemberList(data.reslist);
            } else {
                toast.error(data.msg);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className={`${styles.wrap}`}>
                <form className={styles.formInput} onSubmit={handleSubmit(getMemberAgentList)}>
                    <div className={styles.flexColumn}>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Tài khoản</label>
                            <div className={styles.wrapInput}>
                                <input
                                    {...register('loginname', {
                                        maxLength: {
                                            value: 30,
                                            message: msgAlertInput.generic.maxLength(30),
                                        },
                                        pattern: {
                                            value: msgAlertInput.username.pattern,
                                            message: msgAlertInput.generic.noWhiteSpace,
                                        },
                                    })}
                                    type="text"
                                />
                            </div>
                            {/* base error  */}
                            <div className={globalStyle.errorInput}>{errors['loginname'] && <small>{errors['loginname'].message || msgAlertInput.generic.require}</small>}</div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Số Dư</label>
                            <div className={styles.wrapInput}>
                                <Controller
                                    control={control}
                                    name="samount"
                                    render={({ field: { onChange, name, value } }) => <NumericFormat allowNegative={false} thousandSeparator="," name={name} value={value} onChange={onChange} />}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.flexColumn}>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Thành viên</label>
                            <div className={styles.wrapInput}>
                                <select value={'_'}>
                                    <option value={'_'}>{'Thành viên cấp dưới'}</option>
                                </select>
                            </div>
                        </div>

                        <div className={accountStyles.groupInput}>
                            <label htmlFor="">Tới</label>
                            <div className={styles.wrapInput}>
                                <Controller
                                    control={control}
                                    name="eamount"
                                    render={({ field: { onChange, name, value } }) => <NumericFormat allowNegative={false} thousandSeparator="," name={name} value={value} onChange={onChange} />}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={styles.flexColumn}>
                        <div className={`${accountStyles.groupInput}`}>
                            <label htmlFor="">Sắp Xếp Theo</label>
                            <div className={styles.wrapInput}>
                                <select value={orderData} onChange={(e) => setOrderData(Number(e.target.value))}>
                                    {orderMemberList.map((item) => (
                                        <option value={item.value} key={item.value}>
                                            {item.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className={`${accountStyles.groupInput}`}>
                            <label className={styles.none}>{'test'}</label>
                            <div className={styles.wrapInput}>
                                <button type="submit" className={styles.btnSubmit}>
                                    Tìm Kiếm
                                </button>
                            </div>
                        </div>
                    </div>
                </form>

                <div className={styles.containerTable}>
                    <div className={styles.table}>
                        <div className="row">
                            <p className="title col">ID</p>
                            <p className="title col">Số dư</p>
                            <p className="title col">Đăng ký</p>
                            <p className="title col">Đăng nhập cuối</p>
                            <p className="title col">Lần đăng nhập</p>
                            <p className="title col">Cấp trên</p>
                        </div>
                        {memberList?.length ? (
                            memberList?.map((mem) => (
                                <div className="row" key={mem.id}>
                                    <p className="col">{mem.loginname}</p>
                                    <p className="col">{new Intl.NumberFormat().format(Number(mem.balance))}</p>
                                    <p className="col">{moment(mem.addtime).format('DD/MM/yyyy HH:mm')}</p>
                                    <p className="col">{mem.lastlogintime ? moment(mem.lastlogintime).format('DD/MM/yyyy HH:mm') : '-'}</p>
                                    <p className="col">{mem.logintimes}</p>
                                    <p className="col">{mem.param2}</p>
                                </div>
                            ))
                        ) : (
                            <div className="no-data">
                                <img src={require('assets/images/icons/no-data.png')} alt="" />
                                <p>Không có dữ liệu</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {loading && <LoadingIcon />}
        </>
    );
}

const styles = {
    containerTable: css`
        background-color: #f2f2f2;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
        min-height: 250px;
        border-radius: 5px;
        padding: 4px 4px 18px;
        margin-bottom: 100px;
    `,
    table: css`
        border-radius: 5px;
        overflow: hidden;
        &.table-col-center {
            .col {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .row {
            display: flex;
            border-bottom: 1px solid var(--border-table);
            background-color: #e2dfdc;
            &:first-child {
                border-bottom-color: white;
            }
            &:last-child {
                border-bottom: none;
            }
        }
        .col {
            flex: 1;
            padding: 12px 8px;
            text-align: center;
            font-size: 12.8px;
            font-weight: 300;
        }
        .text-left {
            text-align: left;
        }
        .title {
            color: white;
            font-weight: 300;
            border-right: 1px solid white;
            background-color: ${colors.primary};
            &:last-child {
                border-right: 0;
            }
        }
        .no-data {
            text-align: center;
            padding: 30px;
            height: 180px;
            p {
                margin-top: 8px;
                font-size: 14px;
            }
        }
    `,
    groupAmount: css`
        display: flex;
        gap: 12px;
    `,
    flex30: css`
        flex: 0 0 calc(30% - 32px);
    `,
    flex40: css`
        flex: 0 0 calc(40% - 32px);
    `,
    wrap: css`
        color: black;
        background-color: white;
        border-radius: 8px;
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        padding-bottom: 20px;
    `,
    formInput: css`
        background-color: #f9f9f9;
        padding: 15px 40px 8px;
        border-radius: 3px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
        margin-bottom: 15px;
        border-left: 3px solid #ebc85e;
        display: flex;
        gap: 25px;
        label {
            font-size: 17px;
            font-weight: 300;
        }
    `,
    wrapInput: css`
        input {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
        }
        select {
            border: none;
            background-color: white;
            height: 40px;
            border-bottom: 1px solid black;
            width: 100%;
            color: black;
            box-shadow: none;
            outline: none;
            &:focus {
                border: none;
                box-shadow: none;
            }
        }
    `,
    flexColumn: css`
        flex: 1;
    `,
    none: css`
        color: transparent;
    `,
    btnSubmit: css`
        background: #ffad33 !important;
        border-radius: 3px !important;
        border: 1px solid #c9820a !important;
        padding-left: 20px;
        padding-right: 20px;
        color: white;
        padding-top: 10px;
        padding-bottom: 10px;
    `,
};

export default AgentMember;
